const DROPDOWN_SELECTOR = '.evw-actions [data-evw-menu]';
const UPWARD_CLASS = 'dropdown--upward';
const VIEWPORT_GAP = 12;

const placeDropdown = (dropdown) => {
  const list = dropdown.querySelector('.dropdown__list');
  const trigger = dropdown.querySelector('.dropdown__button');
  if (!list || !trigger) return;

  const triggerRect = trigger.getBoundingClientRect();
  const listHeight = list.scrollHeight;
  const spaceBelow = window.innerHeight - triggerRect.bottom - VIEWPORT_GAP;
  const spaceAbove = triggerRect.top - VIEWPORT_GAP;

  dropdown.classList.toggle(UPWARD_CLASS, listHeight > spaceBelow && spaceAbove > spaceBelow);
};

const EventWebsiteDropdown = {
  start() {
    $(document)
      .off('mouseenter.evwDropdown touchstart.evwDropdown focusin.evwDropdown')
      .on('mouseenter.evwDropdown touchstart.evwDropdown focusin.evwDropdown', DROPDOWN_SELECTOR, (event) => {
        placeDropdown(event.currentTarget);
      });
  }
};

export default EventWebsiteDropdown;
